import React, { useState } from 'react';
import { MapPin, CalendarDays, MoveRight, Search } from 'lucide-react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { CustomButtonWithIcon } from '/src/utils/Button';
import { CustomButton } from '../../../../../../utils/Button';

const StaySmallSmallFilter = () => {
  const [filters, setFilters] = useState({
    location: '',
    checkIn: '',
    checkOut: '',
    guest: '',
    homeType: '',
  });

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleSearch = (e) => {
    e.preventDefault();
  };

  const selectClass =
    ' md:bg-transparent text-sm outline-none w-full cursor-pointer';

  return (
    <form
      onSubmit={handleSearch}
      className="font-duplet md:mx-auto mt-8 mb-6  py-2 md:py-1  md:rounded-2xl md:shadow-md md:bg-white md:border md:border-[#E6E6E6] "
    >
      {/* Desktop view */}
      <div className="hidden md:flex flex-col items-start justify-between w-full ">
        {/* Location */}
        <div className="flex justify-between items-center w-full shadow-lg p-2">
          <div className="w-[35%] flex items-center rounded-full md:rounded-md px-2 py-2 md:py-3  flex- min-w-0">
            <MapPin className="w-5 h-5 mr-3" />
            <select
              name="location"
              value={filters.location}
              onChange={handleChange}
              className={selectClass}
            >
              <option value="">Select a city</option>
              <option value="Lagos">Lagos</option>
              <option value="Abuja">Abuja</option>
              <option value="PH">Port Harcourt</option>
            </select>
          </div>
          <hr className="hidden lg:block border-l border-[#F0F0F0] h-6 mx-4" />
          <div className="flex items-center justify-between gap-2 flex-1 w-[60] ">
            <div className="flex items-center  rounded-full md:rounded-md px-2 md:px-4 py-2 md:py-3  min-w-0">
              <CalendarDays className="w-6 h-6 mr-3 flex-shrink-0" />
              <DatePicker
                name="checkIn"
                selected={filters.checkIn}
                onChange={(date) => setFilters({ ...filters, checkIn: date })}
                placeholderText="Check in"
                className="flex-1 bg-transparent focus:outline-none"
                inline={false}
              />
            </div>
            <MoveRight />
            <div className="flex items-center  rounded-full md:rounded-md px-2 md:px-4 py-2 md:py-3  min-w-0">
              <DatePicker
                name="checkOut"
                selected={filters.checkOut}
                onChange={(date) => setFilters({ ...filters, checkOut: date })}
                placeholderText="Check out"
                className="flex-1 bg-transparent focus:outline-none"
                inline={false}
              />
            </div>
          </div>
          <CustomButtonWithIcon
            icon1="/images/search-circle.svg"
            onClick={handleSearch}
            text={'Search'}
          />
        </div>

        <div className="w-1/2  flex items-center p-2">
          <div className="flex w-full gap-2">
            {/* Guests - 50% */}
            <div className="w-1/2 flex items-center rounded-md px-4 py-3 ">
              <img
                src="/images/guest-icon.svg"
                alt="icon"
                className="w-5 h-5 mr-3"
              />
              <select
                name="guest"
                value={filters.guest}
                onChange={handleChange}
                className="flex-1 bg-transparent focus:outline-none"
              >
                <option value="">Guest</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
              </select>
            </div>

            {/* Home Type - 50% */}
            <div className="w-1/2 flex items-center rounded-md px-4 py-3 ">
              <img
                src="/images/homeType.svg"
                alt="icon"
                className="w-5 h-5 mr-3"
              />
              <select
                name="homeType"
                value={filters.homeType}
                onChange={handleChange}
                className="flex-1 bg-transparent focus:outline-none"
              >
                <option value="">Types of home</option>
                <option value="verified">Verified</option>
                <option value="non-verified">Non-Verified</option>
              </select>
            </div>
          </div>
        </div>

        {/* <CustomButtonWithIcon
          icon1="/images/search-circle.svg"
          onClick={handleSearch}
          text={'Search'}
        /> */}
      </div>
      {/* Mobile view */}
      <div className="flex flex-col md:hidden  w-full">
        {/* Location */}
        <div className="w-full flex items-center rounded-2xl  px-4 py-4 border border-black ">
          <MapPin className="w-5 h-5 mr-3" />
          <select
            name="location"
            value={filters.location}
            onChange={handleChange}
            className={selectClass}
          >
            <option value="">Select a city</option>
            <option value="Lagos">Lagos</option>
            <option value="Abuja">Abuja</option>
            <option value="PH">Port Harcourt</option>
          </select>
        </div>

        <div className="w-full rounded-2xl border  shadow-lg mt-4 p-4">
          <div className="flex items-center justify-between w-full ">
            <div className="flex items-center rounded-full px-2  py-2 flex-1 min-w-0 ">
              <CalendarDays className="w-5 h-5 mr-3 flex-shrink-0" />
              <DatePicker
                name="checkIn"
                selected={filters.checkIn}
                onChange={(date) => setFilters({ ...filters, checkIn: date })}
                placeholderText="Check in"
                className="flex-1 min-w-0 bg-transparent focus:outline-none"
                inline={false}
              />
            </div>
            <MoveRight width={20} />
            <div className="flex items-center rounded-full px-2  py-2 flex-1 min-w-0">
              <DatePicker
                name="checkOut"
                selected={filters.checkOut}
                onChange={(date) => setFilters({ ...filters, checkOut: date })}
                placeholderText="Check out"
                className="flex-1 min-w-0 bg-transparent focus:outline-none pl-4"
                inline={false}
              />
            </div>
          </div>
          <hr />
          <div className=" flex items-center  rounded-full  px-2 py-4 w-full ">
            <img
              src="/images/guest-icon.svg"
              alt="icon"
              className="w-5 h-5 mr-3"
            />
            <select
              name="guest"
              value={filters.guest}
              onChange={handleChange}
              className={selectClass}
            >
              <option value="">Guest</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
            </select>
          </div>
          <hr />
          <div className=" flex items-center rounded-md px-2 py-4 w-full">
            <img
              src="/images/homeType.svg"
              alt="icon"
              className="w-5 h-5 mr-3"
            />
            <select
              name="homeType"
              value={filters.homeType}
              onChange={handleChange}
              className={selectClass}
            >
              <option value="">Types of home</option>
              <option value="verified">Verified</option>
              <option value="non-verified">Non-Verified</option>
            </select>
          </div>
          <hr />

          <div className="mt-4 mb-3">
            <CustomButton onClick={handleSearch} text={'Search'} />
          </div>
        </div>
      </div>
    </form>
  );
};

export default StaySmallSmallFilter;
